import axios from "axios";
import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ISalesPerformanceData } from "../Models/Models";
import * as types from "./Types";

export const setSalesPerformanceData = (sales: ISalesPerformanceData) => ({
    type: types.SALES_PERFORMANCE_SET_DATA,
    data: sales,
});

export const setLoadingSalesPerformanceData = (loading: boolean) => ({
    type: types.SALES_PERFORMANCE_SET_LOADING,
    data: loading,
});

//Thunk Action
export const getSalesPerformanceData: ActionCreator<
  ThunkAction<any, any, any, any>
> = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch(setLoadingSalesPerformanceData(true));

        axios
            .get("/Insights/GetSalesPerformanceData")
            .then((response) => {
                const performanceData: ISalesPerformanceData = response.data.data;

                dispatch(setSalesPerformanceData(performanceData));
                dispatch(setLoadingSalesPerformanceData(false));
            })
            .catch((error) => {
                dispatch(setSalesPerformanceData(null));
                dispatch(setLoadingSalesPerformanceData(false));
            });
    };
};
